import { OnInit, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
    selector: 'app-welcome-wizard-dialog',
    templateUrl: 'welcome-wizard.dialog.html',
    styleUrls: ['welcome-wizard.dialog.scss']
})
export class WelcomeWizardDialog implements OnInit {
    constructor(public dialogRef: MatDialogRef<WelcomeWizardDialog>) {

    }

    ngOnInit(): void {

    }

    onLetsGoClick() {
        this.dialogRef.close();
    }
}